<template>
  <div class="invite-rules-root" :class="{ 'ar-style': $i18n.locale === 'ar' }">
    <div class="custom-nav-block" :style="`paddingTop:${barHeight}px`">
      <van-nav-bar title="" left-arrow @click-left="handleBack">
        <template #left>
          <img class="left-nav" src="./images/arrow-l.png" alt="" />
          <span class="tit-left">{{ $t('lang.call.tit1') }}</span>
        </template>
      </van-nav-bar>
    </div>
    <div class="rules-content">
      <!-- How  to Invite Friends -->
      <div class="rules-block" style="letter-spacing: -0.5px">
        <p class="rules-title right-read">{{ $t('lang.newInvite.k016') }}</p>
        <p class="rules-row right-read">{{ $t('lang.newInvite.k017') }}</p>
        <p class="rules-row right-read">{{ $t('lang.newInvite.k018') }}</p>
        <p class="rules-row right-read">{{ $t('lang.newInvite.k019') }}</p>
        <p class="rules-row right-read">{{ $t('lang.newInvite.k020') }}</p>
        <MyPLabel v-if="baseInfo && baseInfo.videoLimitDay" class="rules-row" :str="$t('lang.newInvite.k035')" :numsOption="[{ value: baseInfo.videoLimitDay }]" />
      </div>

      <!-- Invite Bonus -->
      <div class="rules-block" style="letter-spacing: -1px">
        <p class="rules-title right-read">{{ $t('lang.inRule.inviteBonus') }}</p>
        <!-- 1. The hostess completes at least 1 call(>=15s) within 3 days after registration, you earn 200 -->
        <MyPLabel
          v-if="baseInfo && baseInfo.videoTimes <= 1"
          class="rules-row right-read"
          :str="$t('lang.newInvite.k021')"
          :numsOption="[
            { value: baseInfo.videoTimes || '?' },
            { value: baseInfo.videoMinSeconds || '?' },
            { value: baseInfo.videoLimitDay || '?' },
            { value: baseInfo.rewardBeans || '?', style: 'color:#a338fc' }
          ]" />
        <MyPLabel
          v-if="baseInfo && baseInfo.videoTimes > 1"
          class="rules-row right-read"
          :str="$t('lang.newInvite.k021_1')"
          :numsOption="[
            { value: baseInfo.videoTimes || '?' },
            { value: baseInfo.videoMinSeconds || '?' },
            { value: baseInfo.videoLimitDay || '?' },
            { value: baseInfo.rewardBeans || '?', style: 'color:#a338fc' }
          ]" />
        <p class="rules-row right-read">{{ $t('lang.newInvite.k022') }}</p>
        <p class="rules-row right-read">{{ $t('lang.newInvite.k023') }}</p>

        <div class="zone-block">
          <template v-for="(item, index) in zoneList1">
            <div v-if="(!zone1ShowMore && index < 6) || zone1ShowMore" class="zone-item right-align" :key="item.locationCode">
              <div>
                <img :src="item.locationFlag | imgPath" alt="" />
                {{ item.locationName }}
              </div>
            </div>
          </template>
        </div>
        <div v-show="zoneList1.length > 6" class="more-btn" :class="{ expanded: zone1ShowMore }" @click="zone1ShowMore = !zone1ShowMore">
          {{ $t('lang.newInvite.k024') }}
          <img src="./images/arrow-r.png" alt="" />
        </div>
      </div>

      <!-- Time Limited Bonus -->
      <div class="rules-block" id="limitedBonus" v-if="baseInfo && baseInfo.actRewardIncome">
        <p class="rules-title right-read">{{ $t('lang.newInvite.k025') }}</p>
        <!-- 1. The hostess earns at least 3000 {b} within 3 days after verification, you earn 1000 {b} -->
        <MyPLabel
          v-if="baseInfo && baseInfo.actLimitIncome && baseInfo.actLimitDay && baseInfo.actRewardIncome"
          class="rules-row"
          :str="$t('lang.newInvite.k026')"
          :numsOption="[{ value: baseInfo.actLimitIncome }, { value: baseInfo.actLimitDay }, { value: baseInfo.actRewardIncome, style: 'color:#a338fc' }]" />
        <p class="rules-row right-read">{{ $t('lang.newInvite.k022') }}</p>
        <p class="rules-row right-read">
          {{ $t('lang.newInvite.k027') }}
          <span v-if="baseInfo" style="color: #a338fc">{{ handleTime11(baseInfo.actStartTime) }} - {{ handleTime11(baseInfo.actEndTime) }}</span>
        </p>
        <p class="rules-row right-read">{{ $t('lang.newInvite.k028') }}</p>

        <div class="zone-block">
          <template v-for="(item, index) in zoneList2">
            <div v-if="(!zone2ShowMore && index < 6) || zone2ShowMore" class="zone-item right-align" :key="item.locationCode">
              <div>
                <img :src="item.locationFlag | imgPath" alt="" />
                {{ item.locationName }}
              </div>
            </div>
          </template>
        </div>
        <div v-show="zoneList2.length > 6" class="more-btn right-read" :class="{ expanded: zone2ShowMore }" @click="zone2ShowMore = !zone2ShowMore">
          {{ $t('lang.newInvite.k024') }}
          <img src="./images/arrow-r.png" alt="" />
        </div>
      </div>

      <!-- commission -->
      <div class="rules-block" id="commission">
        <p class="rules-title right-read">{{ $t('lang.dl.commission') }}</p>
        <p class="rules-row right-read">{{ $t('lang.newInvite.k029') }}</p>

        <div class="deliver-line"></div>

        <div class="list-fields right-read">
          <div class="field field1">{{ $t('lang.inRule.th1') }}</div>
          <div class="field field2">
            {{ $t('lang.inRule.th2') }}
            <img :src="getMatchImg('beans')" />
          </div>
          <div class="field field3">{{ $t('lang.newInvite.k030') }}</div>
        </div>
        <div class="list-fields right-read" v-for="item in CommissionNode" :key="item.level">
          <div class="bd-field field1">{{ item.level }}</div>
          <div class="bd-field field2">{{ formatNumber(item.minBeans) }}-{{ formatNumber(item.maxBeans) }}</div>
          <div class="bd-field field3">{{ item.levelRate }}%</div>
        </div>
      </div>

      <!-- Important Notice -->
      <div class="rules-block">
        <p class="rules-title right-read">{{ $t('lang.newInvite.k031') }}</p>
        <p class="rules-row right-read">{{ $t('lang.newInvite.k032') }}</p>
        <p class="rules-row right-read">{{ $t('lang.newInvite.k033') }}</p>
        <p class="rules-row right-read">{{ $t('lang.newInvite.k034') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { rules2PageApi } from '@/api/invite'

export default {
  data() {
    const query = this.$route.query
    return {
      barHeight: query.statusBarHeight || 38,
      zone1ShowMore: false,
      zoneList1: [
        // { locationCode: 'BR', locationFlag: '' }
      ],
      zone2ShowMore: false,
      zoneList2: [
        // { locationCode: 'BR', locationFlag: '' }
      ],
      CommissionNode: [],
      baseInfo: null
    }
  },
  methods: {
    handleBack() {
      this.goPrevious()
    },
    locationTarget() {
      if (this.$route.query.location) {
        const locationDom = document.getElementById(this.$route.query.location)
        locationDom && locationDom.scrollIntoView({ behavior: 'smooth' })
      }
    },
    getRules() {
      rules2PageApi().then((resData) => {
        this.baseInfo = resData
        this.zoneList1 = resData.hostLocations || []
        this.zoneList2 = resData.actHostLocations || []
        this.CommissionNode = resData.commissionNode || []

        this.$nextTick(() => {
          this.locationTarget()
        })
      })
    }
  },
  created() {
    this.getRules()
  }
}
</script>
<style lang="scss" scoped>
.invite-rules-root {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;

  .van-bar-block {
    background: #f9f9fb;
  }

  .rules-content {
    flex: 1;
    width: 100%;
    background-color: #f9f9fb;
    overflow-y: scroll;
  }

  .rules-block {
    background-color: #ffffff;
    padding: 16px 24px;
    margin-bottom: 10px;

    .deliver-line {
      width: 327px;
      height: 1px;
      margin: 0 auto;
      transform: rotateX(45deg);
      background: #ededed;
    }

    .zone-block {
      width: 100%;
      overflow: hidden;
      .zone-item {
        float: left;
        width: 50%;
        margin-bottom: 16px;
        & > div {
          padding: 8px 10px;
          border-radius: 20px;
          border: 1px solid #b2b2b2;
          display: inline-flex;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            margin-right: 6px;
          }
        }
      }
    }

    .more-btn {
      min-width: 150px;
      margin: 0 auto;
      padding: 10px 0;
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #a338fc;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 12px;
        height: 13px;
        margin-left: 4px;
        transform: rotateZ(90deg);
      }
      &.expanded {
        img {
          transform: rotateZ(270deg);
        }
      }
    }

    .list-fields {
      width: 100%;
      display: flex;
      margin: 14px 0;
      .field {
        font-family: RobotoFlex;
        font-weight: 400;
        font-size: 14px;
        color: #b2b2b2;
        text-align: center;
        img {
          width: 14px;
          height: 14px;
          vertical-align: middle;
        }
      }
      .field1 {
        width: 50px;
      }
      .field2 {
        flex: 1;
      }
      .field3 {
        width: 103px;
      }

      .bd-field {
        min-height: 36px;
        font-family: RobotoFlex;
        font-weight: 400;
        font-size: 15px;
        color: #333333;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .rules-title {
    font-family: RobotoFlex;
    font-weight: normal;
    font-size: 17px;
    line-height: 20px;
    color: #333333;
    width: 100%;
    text-align: center;
    font-weight: bolder;
    padding: 16px 0 24px;
  }

  .rules-row {
    font-family: RobotoFlex;
    font-weight: 400;
    font-size: 15px;
    color: #333333;
    line-height: 22px;
    margin-bottom: 12px;
    letter-spacing: -0.5px;

    .beans-img {
      width: 18px;
      height: 18px;
      display: inline-block;
      vertical-align: middle;
    }

    .color-purple {
      color: #a338fc;
    }
  }
}
</style>
<style lang="scss">
.invite-rules-root {
  .custom-nav-block {
    background-color: #f9f9fb;
  }
  .van-nav-bar {
    .van-nav-bar__content {
      .van-nav-bar__left {
        .left-nav {
          width: 20px;
          height: 20px;
        }
        .tit-left {
          font-family: RobotoFlex;
          font-weight: normal;
          font-size: 20px;
          color: #333333;
        }
      }
    }
  }
}

.ar-style.invite-rules-root {
  .rules-block {
    .zone-block {
      .zone-item {
        & > div {
          img {
            margin-left: 4px;
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>
